<template>
  <section>
    <div>
      <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <div class="title" v-if="!fromTreeSection">
          <h3>Datos básicos del chatbot</h3>
          <p>Ingresa el nombre y descripción de tu chatbot</p>
        </div>

        <div>
          <a-form-item label="Nombre del chatbot" name="name">
            <a-input
              v-model:value="formState.name"
              :disabled="disabledInput"
              placeholder="Escribir aquí"
            />
          </a-form-item>
          <a-form-item label="Descripcion del chatbot" name="description">
            <a-textarea
              v-model:value="formState.description"
              :disabled="disabledInput"
              placeholder="Escribe aquí"
              :maxlength="150"
              class="textarea"
            />
            <span class="counter"> {{ formState.description?.length }}/150 </span>
          </a-form-item>
        </div>
        <div>
          <strong>Recuerda</strong>
          <div class="reminder">
            El chatbot no atenderá tickets de WhatsApp si es que no cuentas con saldo disponible
            para este canal.
          </div>
        </div>
      </a-form>
    </div>
  </section>
</template>

<script>
import { defineComponent, ref, reactive, computed, toRaw, inject, watch } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    fromTreeSection: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabledInput: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { expose, emit }) {
    const store = useStore();

    const chatbotDetails = inject("chatbotDetails");

    const formRef = ref();
    const formState = reactive({
      name: chatbotDetails?.value?.name || "",
      description: chatbotDetails?.value?.description || "",
    });
    const chatbots = computed(() => store.getters["getChatbotsList"].results);

    const checkName = async (rule, value) => {
      if (value == "") {
        return Promise.reject("Campo nombre es requerido");
      } else if (
        chatbots.value
          ?.filter((chatbot) => chatbot?.id !== chatbotDetails?.value?.id)
          ?.some((item) => item.name.toLowerCase() === value.toLowerCase())
      ) {
        return Promise.reject("Este nombre ya esta en usó");
      } else {
        return Promise.resolve();
      }
    };
    const rules = {
      name: [{ required: true, validator: checkName, trigger: "change" }],
      description: [
        { required: true, trigger: "change", message: "Campo descripción es requerido" },
      ],
    };

    const handleOk = async (current) => {
      let value = current;
      await formRef.value.validate().then(() => {
        value = current + 1;
      });
      return value;
    };

    expose({ formState: toRaw(formState), handleOk });

    watch(formState, () => emit("activate-button"), { deep: false });

    return {
      formRef,
      formState,
      rules,
    };
  },
  computed: {
    disabled() {
      return this.formState.name == "" || this.formState.description == "";
    },
  },
  watch: {
    disabled: {
      handler(value) {
        this.$emit("disable", value);
      },
    },
  },
  methods: {
    handleReset() {
      this.formRef.resetFields();
    },
  },
});
</script>

<style lang="sass" scoped>
.reminder
  font-size: 13px
  line-height: 20px
  color: #8C8C8C
  font-style: italic

.max-tickets-input
  width: 100%

.picker
  &__label
    display: block
    margin-bottom: 8px
.container__text
  font-size: 12px
  margin-bottom: 3px
  width: 200px
.text-entity
  color: $gray-6
  font-size: 14px
  margin-top: 10px
  margin-bottom: -10px
.padding-10
  padding-top: 10px

.dropdown-default__wrapper
  margin: 36px auto
  width: 190px
  text-align: center
  color: $gray-8
.ant-form-item
  .textarea
    height: 85px

  .counter
    position: absolute
    right: 12px
    bottom: 2px
    color: $gray-6
    font-size: $font-small

.title
  text-align: center

  h2
    color: $gray-9
    margin-bottom: 12px
    font-size: 24px
    font-weight: 600

  p
    color: $gray-8
    font-size: 16px
    margin-bottom: 24px
</style>
